import * as React from 'react'

function PDFooter(): React.ReactElement {
  return (
    <div className="partners-dashboard__footer box">
      <a href="https://may25-staging.icmec.org/" target="_blank">
        View the original page.&nbsp;<span className="fa fa-external-link" aria-hidden="true" />
      </a>
    </div>
  )
}

export default PDFooter;
